import { GET_ALL_COLUMNS_SUCCESS } from "../channel/type";
import { channelType } from "./transformer";

const INITIAL_STATE = {
    isConnecting: false,
    accountData: {},
    dimensions: [],
    metrics: [],
    currency: null,
    metricsUpdated: false,
};

const reducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case `${channelType}.SHOW_CONNECT_ACCOUNT`:
            return { ...state, isConnecting: true };
        case `${channelType}.HIDE_CONNECT_ACCOUNT`:
            return { ...state, isConnecting: false };
        case `${channelType}.GET_ACCOUNT_SUMMARY_SUCCESS`:
            const accountList = Object.values(action.payload.response.map(storeName => {
                const names = storeName.split("-");
                const name = names.map(name => name.charAt(0).toUpperCase() + name.slice(1)).join(" ");
                return {
                    user: { username: name, email: name, storeName: storeName },
                    account: {
                        title: name,
                        subtitle: name,
                        storeName: storeName,
                    },
                };
            }));
            return { ...state, accountData: { users: accountList.map(a => a.user), accountList: accountList.map(a => a.account) } };
        case `${channelType}.DISCONNECT_ACCOUNT_SUCCESS`:
            if (state.accountData.accountList?.length > 0) { return state; }
        case `${channelType}.GET_ACCOUNT_SUMMARY_FAILURE`:
            return JSON.parse(JSON.stringify(INITIAL_STATE));
        case `${channelType}.GET_COLUMNS_SUCCESS`:
            const dimensions = action.payload.columns.filter(c => c.type === "DIMENSION");
            const metrics = action.payload.columns.filter(c => c.type === "METRIC");
            return { ...state, dimensions: dimensions, metrics: metrics, metricsUpdated: true };
        case GET_ALL_COLUMNS_SUCCESS:
            const cc = action.payload.filter(column => column.source === channelType).map(column => ({
                id: column.id,
                name: column.name,
                dataType: column.format ?? "FLOAT",
                group: "Customized",
            }));
            return { ...state, metrics: state.metrics.filter(m => m.group !== "Customized").concat(cc) };
        case `${channelType}.GET_CURRENCY_SUCCESS`:
            return { ...state, currency: action.payload.currency }
        default:
            return state;
    }
};

export default reducer;
